import type { LibraryExam } from "../../../../packages/published-content/library";
import { examRegionCategory, type ExamArchiveItem } from "../../../../packages/exam-catalog/browser";
import { testCatalogStatus } from "./test-catalog-status";

/** Older pinned releases lack catalog metadata and remain readable. */
export function publishedExamArchiveItem(exam: LibraryExam): ExamArchiveItem & { exam: LibraryExam } {
  const region = exam.region ?? "Unknown";
  return {
    exam,
    id: exam.id, title: exam.title, sitting: exam.sitting, year: exam.sitting?.slice(0, 4) ?? "Unknown",
    region, regionCategory: examRegionCategory(region), formLabel: exam.formLabel ?? null,
    assessmentModel: "digital_sat", identityStatus: exam.identityStatus ?? "unresolved", eligibility: exam.eligibility,
    moduleCount: exam.moduleCount ?? 0, completeModules: exam.completeModules ?? 0, alternateModuleCount: 0,
    representedQuestions: exam.available, expectedQuestions: exam.expected, sourceCount: 0,
    coverageRatio: exam.expected > 0 ? exam.available / exam.expected : 0,
    isComplete: exam.isComplete ?? (exam.expected > 0 && exam.available === exam.expected),
    isFullSat: testCatalogStatus(exam) === "full",
    difficulty: exam.difficulty,
    searchText: [exam.id, exam.title, exam.sitting, region, exam.formLabel, exam.eligibility, exam.identityStatus].filter(Boolean).join(" ").toLocaleLowerCase()
  };
}
